<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>科建后台登录入口</span>
      </div>
      <div>
        <el-form
          class="login-form"
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          label-width="80px"
          @keyup.enter.native="handleLogin"
        >
          <el-form-item label="用户名" prop="name">
            <el-input
              name="name"
              v-model="loginForm.name"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              name="password"
              type="password"
              v-model="loginForm.pass"
              autocomplete="off"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="loading"
              @click="handleLogin"
            >登录</el-button>
            <el-button type="text">
              <router-link to="/">回到首页</router-link>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      loginForm: {
        name: "",
        pass: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "密码长度在 5 到 20 个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          this.$message.error("请输入正确的用户名和密码");
          return false;
        }

        this.loading = true;

        this.$http
          .get(
            `User/Login?strUser=${encodeURIComponent(this.loginForm.name)}&strPwd=${encodeURIComponent(this.loginForm.pass)}`
          )
          .then(response => {
            this.loading = false;
            if (response.data && response.data.bRes) {
              this.$message.success("登录成功");
              sessionStorage.setItem("token", response.data.Ticket);
              this.$router.push({ name: "admin" });
            } else {
              this.$message.error("账号或密码错误");
            }
          })
          .catch(error => {
            this.loading = false;
            let msg = "网络或程序异常";
            if (error.message) {
              msg += "：" + error.message;
            }
            this.$message.error(msg);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #409eff;
}

.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a75bb 0%, #14679f 100%);
  padding: 20px;
}

.box-card {
  width: 480px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);

  ::v-deep .el-card__header {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    padding: 20px;
  }
}

.login-form {
  padding: 20px 10px 10px;
}

@media (max-width: 576px) {
  .box-card {
    width: 100%;
  }

  .login-form {
    padding: 10px 0;
  }
}
</style>
